// Each club's visit card types, by club id, as the API last gave them. The
// menu shows Cards once a club has one; card types are not in Firebase.
export const CARD_TYPES_LOADED = 'CARD_TYPES_LOADED'
export const cardTypesLoaded = (siteId, types) => ({
    type: CARD_TYPES_LOADED,
    siteId,
    types,
})

export const reducerCardTypes = (state = {}, action) => {
    switch (action.type) {
        case CARD_TYPES_LOADED:
            return { ...state, [action.siteId]: action.types }
        default:
            return state
    }
}
